import * as Yup from 'yup';

export const AddNewBillsPaymentsBeneficiariesSchema = Yup.object().shape({
  biller: Yup.string().required('Select Biller'),
  customerID: Yup.string().required('Enter your unique ID number'),
});
